const icon = require('vue-svgicon');
icon.register({
    'arrow-left': {
        width: 26,
        height: 26,
        viewBox: '0 0 26 26',
        data: `<path pid="0" d="M1.808 12.932a.75.75 0 00-.171.412c0 .016-.012.03-.012.045 0 .005-.003.008-.003.011 0 .005.002.009.003.013 0 .01.005.018.006.028.01.193.085.365.207.5.01.011.006.029.017.04.01.011.028.006.04.016.01.01.027.007.039.017l8.9 8.088a.793.793 0 101.122-1.12l-7.447-6.77h19.057a.812.812 0 000-1.623H4.509l7.447-6.769A.793.793 0 1010.834 4.7l-8.856 8.048c-.013.01-.02.025-.032.035-.027.022-.066.013-.091.038-.032.032-.022.078-.047.112z" _fill="#000"/>`,
    },
});
